module.exports = __webpack_public_path__ + "assets/word_s2p_default.c85e558a.svg";